import React from 'react';

const ReviewItems = ({item ,handleDeleteItem}) => {

    const {image , price, title } = item

    return (
        <div className="card card-side bg-base-100 shadow-xl my-10">
        <figure ><img src={image} alt={title} className="h-48"/></figure>
        <div className="card-body">
          <h2 className="card-title">{title}</h2>
          <p>${price}</p>
          <div className="card-actions justify-end">
            <button className="btn btn-primary"
            onClick={()=> {
                handleDeleteItem(item)
            }}
            >Delete</button>
          </div>
        </div>
      </div>
    );
};

export default ReviewItems;